import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const AwningsFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "How much can I really save on energy costs?",
      answer: "Our awnings can reduce patio temperatures by 12°C and indoor temperatures by 8°C. Customers typically save $200-400 per summer on AC costs, meaning the awning pays for itself in 5-7 years."
    },
    {
      question: "What's the difference between the Evie awning models?",
      answer: "Evie Breeze is perfect for simple shade needs and smaller spaces. Evie Vista offers the best balance of style and value with half-cassette protection. Evie Horizon provides maximum protection with full-cassette design and premium features. Evie Luxe offers fully customizable luxury options."
    },
    {
      question: "Can I control it with Alexa or Google?",
      answer: "Yes! Our Evie Vista, Evie Horizon, and Evie Luxe models include smart home integration. Simply say \"Alexa, extend the awning\" or use the app from anywhere."
    },
    {
      question: "What happens in high winds?",
      answer: "All our motorized awnings include wind sensors that automatically retract the awning when wind speeds exceed safe levels, protecting your investment."
    },
    {
      question: "How long does installation take?",
      answer: "Most awning installations are completed in 4-6 hours on the same day. Our CSA-certified installers handle all electrical work and clean up completely."
    },
    {
      question: "Do you offer financing?",
      answer: "Yes! We offer flexible financing options starting from $125/month for Evie Breeze, $238/month for Evie Vista, $375/month for Evie Horizon, and $488/month for Evie Luxe models."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-primary mb-4">Common Questions</h2>
          <p className="text-xl text-gray-600">Everything you need to know about our awnings</p>
        </div>

        <div className="space-y-6">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
              >
                <h3 className="text-lg font-semibold text-primary pr-4">
                  {item.question}
                </h3>
                <span className="text-accent text-xl font-bold flex-shrink-0">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="text-gray-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Help */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-primary mb-4">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our awning specialists are here to help you choose the perfect cooling solution.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/awning-quote"
                className="bg-accent text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors inline-block"
              >
                Get Awning Quote
              </a>
              <a
                href="tel:+1234567890"
                className="border-2 border-accent text-accent px-8 py-3 rounded-lg font-semibold hover:bg-accent hover:text-white transition-colors inline-block"
              >
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwningsFAQ;
